import { render, staticRenderFns } from "./TerminosView.vue?vue&type=template&id=20e75448&scoped=true&"
import script from "./TerminosView.vue?vue&type=script&lang=js&"
export * from "./TerminosView.vue?vue&type=script&lang=js&"
import style0 from "./TerminosView.vue?vue&type=style&index=0&id=20e75448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e75448",
  null
  
)

export default component.exports